

















































import { Component, Vue } from "vue-property-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { IPartner } from "@/types/partner";

@Component({
  components: {},
})
export default class extends Vue {
  @Action("partner/salesGet")
  public getPartner!: (id: number) => void;

  @Getter("partner/single")
  public partner!: IPartner;

  @Mutation("partner/clear")
  public clear!: () => void;

  public partner_id = 0;

  public items: { title: string; icon: string; url: string; exact: boolean }[] =
    [];

  private async created() {
    this.partner_id = Number(this.$route.params.partner_id);
    this.clear();

    this.items = [
      {
        title: "Dashboard",
        icon: "mdi-folder-account",
        url: `/sales/partner/${this.partner_id}`,
        exact: true,
      },
      {
        title: "Staff",
        icon: "mdi-folder-account",
        url: `/sales/partner/${this.partner_id}/staff`,
        exact: false,
      },
    ];

    await Promise.all([this.getPartner(this.partner_id)]);
  }
}
